import * as React from 'react'
import { TrainingCard } from './TrainingCard'
import axios from 'axios'
import { Link } from 'react-router-dom'

//The Home component show the list of all trainings available
export const Home: React.FunctionComponent = (props) => {

    interface ITraining {
        Id: Number,
        Created: Date,
        Name: string,
        Price: Number,
        Summary: string,
        PresentationVideo: string,
        AllowedUsers: Array<any>
    }

    const [trainingArray, setTrainingArray] = React.useState<ITraining[]>([])

    React.useEffect(() => {
        axios.get('https://LaurenceBrun.eu.pythonanywhere.com/training/')
        .then(function (response: any) {
            let arrayTraining = response.data.map((training: any) => {
                const Training: ITraining = {
                    Id : training.id,
                    Created : training.created, 
                    Name : training.title,
                    Price : training.price, 
                    Summary : training.description, 
                    PresentationVideo : training.presentationVideoLink,
                    AllowedUsers : training.allowedUsers
                }
                return Training
            })
            arrayTraining = arrayTraining.filter((training: any) => {
                if(training.Price !== "1.00") {
                    return training
                }
            })
            setTrainingArray(arrayTraining)
        })
        .catch(function(error: any) {
            alert("Une erreur est survenue, veuillez recharger la page !")
            console.log(error)
        })
    }, [])

    let sortedTrainingArray: Array<ITraining> = trainingArray.sort((a: ITraining, b: ITraining) => {
        return new Date(a.Created).getTime() - new Date(b.Created).getTime() 
    })

    const displayEmptyPage = () => {
        if(!trainingArray.length) {
            return(
                <div>Le développement de la plateforme de E-Formation est encore en cours. Vous retrouverez ici prochainement toutes les formations d'en-deuil-et.com !</div>
            )
        }
    }

    return(
        <div>
            <div className="PageTitle">
                Liste des Formations
            </div>
            <p>Pour toute demande de formation personnalisée vous pouvez me contacter en cliquant <a href="https://en-deuil-et.com/index.php?contact">ici</a>.</p>
            {displayEmptyPage()}
            <ul className="TrainingGrid">
                {
                    sortedTrainingArray.map(({Id, Name, Price, Summary, PresentationVideo, AllowedUsers}) => (
                        <Link to={`/training/${Id}`} style={{textDecoration: 'none'}}><TrainingCard id = {Id} 
                            name={Name} 
                            price={Price} 
                            summary={Summary}
                            presentationVideo={PresentationVideo}
                            allowedUsers={AllowedUsers} /></Link>
                    ))
                }
            </ul>
        </div>
    )
}